'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _domUtil = require('../../../utils/domUtil');

require('./StaticURLField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticURLField = function StaticURLField(_ref) {
    var url = _ref.url,
        className = _ref.className;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('StaticURLField', className), value: url, onFocus: _domUtil.selectAndCopyInput, readOnly: true });
};

StaticURLField.propTypes = {
    url: _propTypes2.default.string,
    className: _propTypes2.default.string
};

exports.default = StaticURLField;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/StaticURLField.js
// module id = 700
// module chunks = 0